module.exports = __webpack_public_path__ + "assets/img/news2.3.d89cb10c.png";